import React from "react";


export const TesCarousel = () => {
 const testimonials = [
    { name: "Francesca Morlino ", text: "I have been lucky to find Abraham while I was looking for a local tour operator to organize a tailored tour for my family and my friends. Abraham has helped me since the beginning to organise my tour, attentively responding to all my needs and “unusual request”. ", image: "https://africantraveltour.com/assets/img/testimonials-1.webp" },
    { name: " Margherita", text: "Beautiful experience, visited Serengeti, Ngoro ngoro and Tarangire. We have seen, up close, all possible animals. We found ourselves in the middle of a herd of elephants very close to the matriarch and the cubs", image: "https://africantraveltour.com/assets/img/testimonials-2.webp" },
    { name: "Jac", text: "We went on a 5 day safari in September with African Travel Tour with Ayubu as our guide. This was one of the most amazing experiences ever! We got to see way more than we ever thought we would. ", image: "https://africantraveltour.com/assets/img/testimonials-3.webp" },
    { name: "Mehdi", text: "It was a great 3 days safari, we had the chance to see all the animals with our experienced tour guide Ayoubo", image: "https://africantraveltour.com/assets/img/testimonials-4.webp" },
    { name: "Chima", text: "I had the wonderful pleasure of doing a two day safari with African Travel Tour that included one day Ngorongoro and one day Serengeti", image: "https://africantraveltour.com/assets/img/testimonials-5.webp" },
    { name: "Ronit", text: "We just returned from an amazing 10 days safari birthday present trip with our two grandsons (13 and 16) in Tanzania", image: "https://africantraveltour.com/assets/img/testimonials-6.webp" },
    { name: "Trevor", text: "African Travel Tour listened to our requests and developed a 6 day 5 night Safari that was tailored to our expectations and requirements (father 72 yrs old and myself 41 yrs old)", image: "https://africantraveltour.com/assets/img/testimonials-7.webp" },
    { name: "Luba", text: "Abraham met us at the Arusha airport, which was very nice. Suggested to take Tarangeti instead of lake Manyara . Glad that we did as we saw elephants , girafs more animals but the most important baobabs.", image: "https://africantraveltour.com/assets/img/testimonials-8.webp" },
    { name: "Tom", text: "We booked both our 7 day kilimanjaro trek and 4 day safari through Abraham and everything was perfectly organized. ", image: "https://africantraveltour.com/assets/img/testimonials-11.webp" },


  ];

  return (
    <div
      id="testimonialCarousel"
      className="carousel slide py-5 text-center"
      data-bs-ride="carousel"
    >
      {/* Carousel Indicators */}
      <div className="carousel-indicators mb-0 ">
        {testimonials.map((_, idx) => (
          <button
            key={idx}
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide-to={idx}
            className={idx === 0 ? "active" : ""}
            aria-current={idx === 0 ? "true" : "false"}
            aria-label={`Slide ${idx + 1}`}
          ></button>
        ))}
      </div>

      {/* Carousel Inner */}
      <div className="carousel-inner container">
        {testimonials.map((t, idx) => (
          <div
            key={idx}
            className={`carousel-item ${idx === 0 ? "active" : ""}`}
          >
            <div className="d-flex flex-column align-items-center justify-content-center">
              <div
                className="rounded-circle border border-3 border-warning overflow-hidden mb-3"
                style={{ width: "120px", height: "120px" }}
              >
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-100 h-100 object-fit-cover"
                />
              </div>

              <p className="px-3 px-md-5 " style={{ maxWidth: "600px" }}>
                "{t.text}"
              </p>

              <h5 className="fw-bold mt-3">{t.name}</h5>
            </div>
          </div>
        ))}
      </div>

      {/* Carousel Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#testimonialCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon rounded-circle p-3" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#testimonialCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon  rounded-circle p-3" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};
